import { composeIO } from 'react-compose-io'
import { regularizacaoOPsIO } from './RegularizacaoOPs.IO'
import { RegularizacaoOPsView } from './RegularizacaoOPs.View'

export const RegularizacaoOPs = composeIO(RegularizacaoOPsView, regularizacaoOPsIO)
